import React, { useEffect } from 'react';
import { trackEvent } from '@99designs/tracking';
import Button from '@99designs/frontend-components/components/Button/Button';
import styled, { css } from 'styled-components';
import Scroll from '../../../../Scroll';
import { animateItem } from './sharedStyles';
import { media, spaces } from '../../../../../../shared/lib/styles';
import { between } from '../../../../../../shared/spa/core-components/utils/media';
import ScrollToSectionButton from '../../../../Scroll/ScrollToSectionButton';
import CTAButton from '../../../HeroSection/CTAButton';
import { InteractionProps } from '../../../CategoryConfigProvider';

interface Props {
    categoryKey: string;
    goToNextStep?: () => void;
    hasAnimation: boolean;
    heroInteraction: InteractionProps;
}

const Wrapper = styled.div`
    min-width: 1240px;
    padding-bottom: ${spaces.space6}px;

    @media ${media('normal')} {
        min-width: 1200px;
    }

    @media ${media('small')} {
        min-width: auto;
    }
`;

const InnerWrapper = styled.nav`
    display: flex;
    width: 900px;
    padding: ${spaces.space3}px 0px ${spaces.space7}px 0px;
    margin-left: ${spaces.space10}px;

    @media ${media('small')} {
        width: auto;
        padding: 0px;
    }

    ${between('small', 'medium')} {
        margin-left: 0;
    }
`;

const Item = styled.div<{ hasAnimation: boolean }>(
    ({ hasAnimation }) => css`
        :not(:last-child) {
            margin-right: ${spaces.space7}px;
        }

        ${hasAnimation && animateItem}
    `
);

function IntentSelect({ goToNextStep, categoryKey, hasAnimation, heroInteraction }: Props) {
    useEffect(() => {
        trackEvent('Viewed Prelaunch Interactive', {
            category: categoryKey,
        });
    }, [categoryKey]);

    return (
        <Scroll gridWidth={1300}>
            <Wrapper>
                <InnerWrapper>
                    <Item hasAnimation={hasAnimation}>
                        {categoryKey === 'logo-design' ? (
                            <Button variations={['jumbo', 'primary']} onClick={goToNextStep}>
                                {__('Get a logo')}
                            </Button>
                        ) : (
                            <CTAButton
                                link={heroInteraction.link}
                                buttonColor={heroInteraction.buttonColor}
                                categoryKey={categoryKey}
                                cta_location="hero section cta"
                            >
                                {heroInteraction.buttonText}
                            </CTAButton>
                        )}
                    </Item>
                    <Item hasAnimation={hasAnimation}>
                        <ScrollToSectionButton
                            id="#how-it-works"
                            name={__('How it works')}
                            categoryKey={categoryKey}
                            trackEventTitle="Clicked Prelaunch Interactive Intention"
                            trackEventName="how it works"
                            offset={75}
                        />
                    </Item>
                    <Item hasAnimation={hasAnimation}>
                        <ScrollToSectionButton
                            id="#reviews"
                            name={__('Reviews')}
                            categoryKey={categoryKey}
                            trackEventTitle="Clicked Prelaunch Interactive Intention"
                            trackEventName="review"
                            offset={75}
                        />
                    </Item>
                </InnerWrapper>
            </Wrapper>
        </Scroll>
    );
}

export default IntentSelect;
